import {ChangeDetectionStrategy, Component, computed, effect, input, signal} from "@angular/core";
import {MøteId, TynnMøteModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {RopertKomponent} from "web-ng2/delt/komponenter/ropert/ropert";
import {TranslateModule} from "@ngx-translate/core";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import {PresentasjonsmodusTjeneste} from "web-ng2/tjenester/PresentasjonsmodusTjeneste";
import {Sakstidspunkter} from "felles-ng2/tjenester/Sakstidspunkter";
import {toObservable, toSignal} from "@angular/core/rxjs-interop";
import {switchMap} from "rxjs";
import {map} from "rxjs/operators";
import {MatIcon} from "@angular/material/icon";

const debug = initDebugger('AktiverPresentasjonsmodusTipsKomponent');

/**
 * Viser tips om å aktivere presentasjonsmodus når et møte pågår
 */
@Component({
    selector: 'aktiver-presentasjonsmodus-tips',
    templateUrl: 'aktiver-presentasjonsmodus-tips.html',
    styleUrl: 'aktiver-presentasjonsmodus-tips.scss',
    imports: [
        RopertKomponent,
        TranslateModule,
        MatIcon
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AktiverPresentasjonsmodusTipsKomponent {
    static ajsSelector = 'aktiverPresentasjonsmodusTips';

    private static skjultAktiverPresentasjonsmodusTipsRegister: { [møteId: MøteId]: boolean } = {};

    moete = input.required<TynnMøteModell>();

    erAktivtMoete = toSignal(toObservable(this.moete).pipe(
      switchMap(møte => this.sakstidspunkter.forMøteSomObserverbar(møte.id)),
      map(sakstidspunkter => sakstidspunkter.harSakSomBehandlesNåPlussMinusEnTime(this.klokke.nåSomZonedDateTime()))
    ), {initialValue: false});

    tipsVises = computed(() =>
      this.erAktivtMoete() &&
      !this.presentasjonsmodusTjeneste.erAktivert() &&
      !this.eksplisittSkjult());

    private eksplisittSkjult = signal(false);

    constructor(private klokke: Klokke, private sakstidspunkter: Sakstidspunkter, private presentasjonsmodusTjeneste: PresentasjonsmodusTjeneste) {
        effect(() => {
            if (AktiverPresentasjonsmodusTipsKomponent.skjultAktiverPresentasjonsmodusTipsRegister[this.moete().id])
                this.eksplisittSkjult.set(true);
        });
    }

    aktiverPresentasjonsmodusOgSkjuleTips() {
        this.presentasjonsmodusTjeneste.aktiver();
        this.skjulTips();
    }

    skjulTips() {
        AktiverPresentasjonsmodusTipsKomponent.skjultAktiverPresentasjonsmodusTipsRegister[this.moete().id] = true;
        this.eksplisittSkjult.set(true);
    }

}
